var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages.length)?_c('div',{staticClass:"alert alert-danger form-api-errors",attrs:{"role":"alert"}},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index},[_vm._v(_vm._s(message))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }